<template>
  <div>
    <br /><br />
    <h2 style="text-align:center">
      {{ msg }}
      <a href="/#/fund"><i class="el-icon-d-arrow-right"></i></a>
    </h2>

    <el-divider id="divider1"></el-divider>
    <h2 style="text-align:center">
      {{ msg1 }}
    </h2>
  </div>
</template>

<script>
export default {
  name: "Divider",
  data() {
    return {
      msg: "基金报告",
      msg1: "REPORT"
    };
  }
};
</script>

<style scoped>
#divider1 {
  margin: 0 auto;
  width: 120px;
  border-top: 3px solid #97b9ff;
}

a {
  text-decoration: none;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/divider.vue